import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isNumber } from 'underscore';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { professionalServicePropTypes } from '../consts/prop-types';

const UnStyledSmartProfessionalServiceCard = ({
  item,
  classes,
}) => {
  const {
    name,
    price,
    description,
  } = item;

  return (
    <div key={name} className={classNames(classes.container, 'view-service-item', 'card')}>
      <span className={classes.name}>{name}</span>
      {
        isNumber(price) && <span className={classes.price}>{`$${price}`}</span>
      }
      {
        description && <span className={classes.description}>{description}</span>
      }
    </div>
  );
};

UnStyledSmartProfessionalServiceCard.propTypes = {
  item: professionalServicePropTypes.isRequired,
  classes: PropTypes.shape({}).isRequired,
};

export const SmartProfessionalServiceCard = withDefaultStyles(
  UnStyledSmartProfessionalServiceCard,
  (_, { palette = {} }) => ({
    container: {
      height: '275px',
      width: '340px',
      position: 'relative',
      padding: '20px 13px 40px',
      margin: '0px 15px 50px',
      boxShadow: '0px 1.6px 3.6px rgba(0, 0, 0, 0.132), 0px 0.3px 0.9px rgba(0, 0, 0, 0.108)',
      borderRadius: 2,
      background: palette.cardBackground,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      lineHeight: '20px',
      textAlign: 'center',
      fontSize: '16px',
      lineBreak: 'anywhere',
    },
    name: {
      fontWeight: 'bold',
      fontSize: '24px',
      marginBottom: '15px',
      lineHeight: '24px',
    },
    price: {
      marginBottom: '15px',
    },
    description: {
      marginBottom: '30px',
    },
  })
);
